<template>
    <v-footer
      dark
      padless
    >
      <v-card
        flat
        tile
        color="primary"
        class="white--text"
        style="width:100%"
      >
  
        <v-card-text class="primary--text pt-0 px-4 px-md-10" style="width:100%;background-color:#e7c6c8;border-top:5px solid #560354">
            <v-container>
                <v-row>
                    <v-col cols="12" sm="12" md="3">
                        <div class="text-h6 text-md-h4 white--text text-uppercase">Back to Work Connect</div>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <p class="text-body-1">Back To Work Connect - Connecting supports, skills and job opportunities to guide you back to work.</p>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" offset-md="1" >
                        <div class="text-h6 text-md-h4 white--text text-uppercase">Info</div>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <v-icon color="primary">mdi-post</v-icon> <span class="text-body-1"><a href="https://backtoworkconnect.ie/careerhub/blog/" target="_blank">Resources</a></span>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <v-icon color="primary">mdi-information</v-icon> <span class="text-body-1"><a href="https://backtoworkconnect.ie/careerhub/about/" target="_blank">About Us</a></span>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <v-icon color="primary">mdi-advertisements</v-icon> <span class="text-body-1"><a href="https://backtoworkconnect.ie/careerhub/advertising-with-us/" target="_blank">Advertising with Us</a></span>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;" v-if="0"></v-divider>
                        <v-icon color="primary" v-if="0">mdi-treasure-chest</v-icon> <span class="text-body-1" v-if="0"><a  href="https://backtoworkconnect.ie/careerhub/supports/" target="_blank">Resources</a></span>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <v-icon color="primary">mdi-email</v-icon> <span class="text-body-1"><a href="https://backtoworkconnect.ie/careerhub/contact/" target="_blank">Contact us</a></span>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" offset-md="1" >
                        <div class="text-h6 text-md-h4 white--text text-uppercase">Reach Us</div>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <v-icon color="primary">mdi-email</v-icon> <span class="text-body-1">info@backtoworkconnect.ie</span>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <span class="text-body-1"><v-icon color="primary">mdi-map</v-icon>  Back To Work Connect Unit 11 Naas Road Business Park, Muirfield Drive, Inchicore, D12 PN50</span>
                        <v-divider class="my-3 my-md-5" style="background-color:#560354;"></v-divider>
                        <span class="text-body-1"><v-icon color="primary">mdi-phone</v-icon> 0894057839</span>
                        
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
  
        <v-divider></v-divider>
  
        <v-card-text class="white--text">
            <v-row>
                <v-col cols="12" sm="12" md="2">
                    &copy; {{ new Date().getFullYear() }} — <strong>BackToWorkConnect.ie</strong>
                </v-col>
                <v-col cols="12" sm="12" md="3" offset-md="7">
                    <v-btn
                        v-for="icon in icons"
                        :key="icon.i"
                        class="mx-4 white--text"
                        icon
                        :href="icon.url" target="_blank"
                    >
                        <v-icon size="24px">
                        {{ icon.i }}
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
          
        </v-card-text>
      </v-card>
    </v-footer>
</template>

<script>
  export default {
    data: () => ({
      icons: [
        {i:'mdi-facebook',url:'https://www.facebook.com/backtoworkconnect'},
        {i:'mdi-twitter',url:'https://twitter.com/back2workconect'},
        {i:'mdi-linkedin',url:'https://www.linkedin.com/company/20292620/'},
        {i:'mdi-instagram',url:'https://www.instagram.com/backtoworkconnect/'},
      ],
    }),
  }
</script>